import { ReactComponent as CommentsCount } from 'assets/images/videoReactions/commentsCount.svg';
import styled from 'styled-components/macro';

const CommentsCountIcon = styled(CommentsCount)`
  width: ${props => props.width || '17px'};
  height: ${props => props.height || '17px'};
`;

export default CommentsCountIcon;
